// Luminance perçue (0-255) au-delà de laquelle une couleur se confond avec un
// fond blanc : blanc, gris clair, jaune pâle...
export const LIGHT_COLOR_LUMINANCE = 200;

// Vrai pour une couleur CSS (quelle que soit son écriture : #rgb, rgb(), nom...)
// proche du blanc. Une couleur translucide est évaluée une fois posée sur un
// fond blanc, où elle apparaît plus claire.
export const isLightColor = (color) => {
  if (!color || color === 'transparent') return false;
  // Le canvas normalise en #rrggbb, ou rgba(r, g, b, a) si l'alpha est < 1 ; une
  // valeur invalide laisse la valeur d'origine (#010203 ici, sombre).
  const ctx = document.createElement('canvas').getContext('2d');
  if (!ctx) return false;
  ctx.fillStyle = '#010203';
  ctx.fillStyle = color;
  const normalized = ctx.fillStyle;
  let rgba;
  if (normalized.startsWith('#')) {
    rgba = [1, 3, 5].map((i) => parseInt(normalized.slice(i, i + 2), 16)).concat(1);
  } else {
    rgba = normalized.match(/[\d.]+/g)?.map(Number);
  }
  if (!rgba || rgba.length < 3) return false;
  const [r, g, b, a = 1] = rgba;
  const overWhite = [r, g, b].map((channel) => channel * a + 255 * (1 - a));
  return 0.299 * overWhite[0] + 0.587 * overWhite[1] + 0.114 * overWhite[2] > LIGHT_COLOR_LUMINANCE;
};
